// extracted by mini-css-extract-plugin
module.exports = {"content":"PromoGuideSheet_content__3Pqfs","description":"PromoGuideSheet_description__JNZFY","container":"PromoGuideSheet_container__7aaTI","title":"PromoGuideSheet_title__3z1-3"};